"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _arrowLeftCircleIcon = _interopRequireDefault(require("../../../asset/icon/arrow-left-circle.icon.js"));

var _arrowRightCircleIcon = _interopRequireDefault(require("../../../asset/icon/arrow-right-circle.icon.js"));

var _MediaStory = _interopRequireDefault(require("./MediaStory/MediaStory"));

var _ProgressList = _interopRequireDefault(require("./Progress/ProgressList"));

var _Channel = _interopRequireDefault(require("./Channel/Channel"));

var css = _interopRequireWildcard(require("./MediaStories.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const MediaStories = props => {
  const {
    stories,
    channelIconLink,
    zIndex,
    ...otherProps
  } = props;
  const [currentVideoDuration, setCurrentVideoDuration] = (0, _react.useState)(0); // Pause-Play

  const [paused, setPause] = (0, _react.useState)(false);
  const handlePlay = (0, _react.useCallback)(() => setPause(false), []);
  const handlePause = (0, _react.useCallback)(() => setPause(true), []); // Current story loading

  const [currentStoryLoaded, setCurrentStoryLoading] = (0, _react.useState)(false);
  const setNewCurrentStoryLoading = (0, _react.useCallback)(status => {
    setCurrentStoryLoading(status);
    handlePlay();
  }, [handlePlay]); // Current story error

  const [hasMediaError, setMediaErrorStatus] = (0, _react.useState)(false);
  const setNewMediaErrorStatus = (0, _react.useCallback)(() => {
    setCurrentStoryLoading(false);
    setMediaErrorStatus(true);
    handlePlay();
  }, [handlePlay]); // Active story id

  const [activeStoryId, setActiveStoryId] = (0, _react.useState)(0);
  const setNewActiveStoryId = (0, _react.useCallback)(storyId => {
    // When tab is changing we set up pause and when media is loaded it will continue playing
    setActiveStoryId(storyId);
    setMediaErrorStatus(false);
    setCurrentStoryLoading(false);
    setPause(true);
  }, []);
  const updateNextStoryId = (0, _react.useCallback)(() => {
    const newStoryId = activeStoryId < stories.length - 1 ? activeStoryId + 1 : activeStoryId;

    if (newStoryId !== activeStoryId) {
      setNewActiveStoryId(newStoryId);
    }
  }, [activeStoryId, setNewActiveStoryId, stories.length]);
  const updatePreviousStoryId = (0, _react.useCallback)(() => {
    setNewActiveStoryId(activeStoryId > 0 ? activeStoryId - 1 : activeStoryId);
  }, [activeStoryId, setNewActiveStoryId]);
  const handleKeyDown = (0, _react.useCallback)(e => {
    if (e.key === 'ArrowLeft') {
      updatePreviousStoryId();
    } else if (e.key === 'ArrowRight') {
      updateNextStoryId();
    } else if (e.key === ' ') {
      // e.key - ' ' === Space
      setPause(prev => !prev);
    }
  }, [updatePreviousStoryId, updateNextStoryId]);
  (0, _react.useEffect)(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  const playingStateComponent = paused ? (0, _pragma.createFelaElement)(_.PlayIcon, {
    css: css.playingStateIcon,
    cssProps: {
      isContentLoaded: currentStoryLoaded
    },
    size: "large",
    onClick: handlePlay
  }) : (0, _pragma.createFelaElement)(_.PauseIcon, {
    css: css.playingStateIcon,
    cssProps: {
      isContentLoaded: currentStoryLoaded
    },
    size: "large",
    onClick: handlePause
  });
  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.root,
    cssProps: {
      zIndex
    }
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    onClick: updatePreviousStoryId,
    css: css.changeSlideButton,
    cssProps: {
      type: 'prev'
    }
  }, (0, _pragma.createFelaElement)("img", {
    src: _arrowLeftCircleIcon.default,
    alt: "Prev"
  })), (0, _pragma.createFelaElement)(_.View, {
    onClick: updateNextStoryId,
    css: css.changeSlideButton,
    cssProps: {
      type: 'next'
    }
  }, (0, _pragma.createFelaElement)("img", {
    src: _arrowRightCircleIcon.default,
    alt: "Next"
  })), (0, _pragma.createFelaElement)(_.View, {
    css: css.wrapper
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    css: css.headerWrapper,
    padding: ['xxsmall', 'xsmall']
  }, (0, _pragma.createFelaElement)(_ProgressList.default, {
    stories: stories,
    activeStoryId: activeStoryId,
    currentVideoDuration: currentVideoDuration,
    isPaused: paused,
    hasMediaError: hasMediaError,
    onNext: updateNextStoryId
  }), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    justifyContent: channelIconLink ? 'space-between' : 'flex-end',
    alignItems: "center",
    padding: ['xsmall', 'small']
  }, channelIconLink && (0, _pragma.createFelaElement)(_Channel.default, {
    channelIconLink: channelIconLink
  }), playingStateComponent)), (0, _pragma.createFelaElement)(_MediaStory.default, {
    story: stories[activeStoryId],
    isPaused: paused,
    isLoaded: currentStoryLoaded,
    hasMediaError: hasMediaError,
    onPlay: handlePlay,
    onPause: handlePause,
    onChangeVideoDuration: setCurrentVideoDuration,
    onMediaLoaded: () => setNewCurrentStoryLoading(true),
    onError: setNewMediaErrorStatus
  })));
};

MediaStories.displayName = 'MediaStories';
var _default = MediaStories;
exports.default = _default;
//# sourceMappingURL=MediaStories.js.map